<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.h6.basic800--text {{ $t('duplicate_product') }}
        v-divider.basic300
        v-card-text.pa-0
          v-card.pa-4
            v-form(ref="form")
              .field-name
                p.mb-2.label.basic600--text.text-uppercase {{ $t('product_name') }}
                v-text-field(v-model="productName" placeholder="Write product name here" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="145")
              div
                y-checkbox.my-auto.mx-0.pa-0(v-model="productImage" hide-details)
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('include_product_image') }}
              div
                y-checkbox.my-auto.mx-0.pa-0(v-model="productVideo" hide-details)
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('include_product_video') }}
              div(v-if="product.has_variants")
                y-checkbox.my-auto.mx-0.pa-0(v-model="productVariants" hide-details)
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('include_variants') }}
              div(v-if="product.has_addons")
                y-checkbox.my-auto.mx-0.pa-0(v-model="productAddons" hide-details)
                  template(v-slot:label)
                    div.p1.primary--text {{ $t('include_addons') }}

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click='clickSaveNew' :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('duplicate') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DuplicateProduct',
  props: ['open', 'parentProduct'],
  components: {},
  data: () => ({
    productName: null,
    productImage: null,
    productVideo: null,
    productVariants: false,
    productAddons: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
    },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    product: {
      get() {
        return this.parentProduct
      },
      set(newValue) {
        this.$emit('update:parentProduct', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.productName = this.product.name
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSaveNew () {
      this.isLoading = true
      let params = {
        product_name: this.productName,
        copy_images: this.productImage,
        copy_videos: this.productVideo,
        copy_variants: this.productVariants,
        copy_addons: this.productAddons,
      }
      this.axios.post(`/products/${this.product.id}/duplicate`, params)
        .then(resp => {
          this.showModal = false
          this.$emit('duplicated', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>
